import "./App.css";
import React, { useState, useEffect } from "react";
import Terminal from "./components/Terminal";
import GifContainer from "./components/GifContainer";
import TerminalTest from "./components/TerminalTest";


function App() {
  const [showOrientationWarning, setShowOrientationWarning] = useState(false);

  // Function to check screen orientation
  const checkOrientation = () => {
    const isMobile = /iPhone|iPad|Android|Mobile|Windows Phone/i.test(navigator.userAgent);
    if (isMobile) {
      setShowOrientationWarning(true); 
    }
    if (window.innerHeight > window.innerWidth) {
      setShowOrientationWarning(true);  
    } else {
      setShowOrientationWarning(false); 
    }
  };

  // Check on initial load and when screen resizes
  useEffect(() => {
    checkOrientation();
    window.addEventListener("resize", checkOrientation);
    
    return () => window.removeEventListener("resize", checkOrientation);
  }, []);

  return (
    <div className="app-container">
      {/* Orientation Warning Popup */}
      {showOrientationWarning && (
        <div className="orientation-warning">
          <h2>Not Available</h2>
          <p>You can use this application on desktop only. </p>
        </div>
      )}

      {/* Main Content (Only visible if in landscape mode) */}
      {!showOrientationWarning && (
        <div className="content-wrapper"> 
            <div className="terminal-wrapper">
              <TerminalTest/>
              {/* <Terminal /> */}
          </div>

          <GifContainer
            gifFiles={[
              "/gifs/gif3.gif",
              "/gifs/gif4.gif",
            ]}
          />
        </div>
      )}
    </div>
  );
}

export default App;
